import { render, staticRenderFns } from "./DomainPosting.vue?vue&type=template&id=5e3e206a&scoped=true&"
import script from "./DomainPosting.vue?vue&type=script&lang=js&"
export * from "./DomainPosting.vue?vue&type=script&lang=js&"
import style0 from "./DomainPosting.vue?vue&type=style&index=0&id=5e3e206a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3e206a",
  null
  
)

export default component.exports